export function Incomplete() {
  return (
    <svg width="16" height="16" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="45" stroke="currentColor" strokeWidth="8" fill="none" />
      <line x1="20" y1="50" x2="80" y2="50" stroke="currentColor" strokeWidth="8" />
    </svg>
  );
}
